var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"d3"}},[_c('div',{attrs:{"id":"moon"}}),_c('small',[_vm._v(_vm._s(_vm.phaseText)+" ("+_vm._s(Number(100 * this.illuminated).toFixed(1))+"%)")]),_c('div',{attrs:{"id":"horizon"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }